module.exports = __webpack_public_path__ + "img/rejected-claim-icon.c96c12a9.svg";